export function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function dataURLToBlob(dataURL) {
  const parts = dataURL.split(';base64,');
  const contentType = parts[0].split(":")[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  const blob = new Blob([uInt8Array], { type: contentType, filename: 'test.png' });
  return blob
}

export function blobToFile(blob, filename, type) {
  const file = new File([blob], filename, { type: type || 'images/png' });
  return file
}

export function downloadFile(dataUrl, filename) {
  const blob = dataURLToBlob(dataUrl);
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.style = "display: none";
  a.href = url;
  a.download = filename;

  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
}

export function debounce(func, delay) {
  let timer; // 创建一个计时器变量

  return function () {
    clearTimeout(timer); // 清除之前的计时器

    timer = setTimeout(() => {
      func(); // 在指定的延迟时间内调用传入的函数
    }, delay);
  };
}

export function throttle(func, interval) {
  let lastTime = null; // 记录上一次执行的时间戳

  return function () {
    const currentTime = Date.now(); // 获取当前时间戳

    if (lastTime === null || currentTime - lastTime >= interval) {
      func(); // 超过指定的时间间隔就执行函数

      lastTime = currentTime; // 更新上一次执行的时间戳
    }
  };
}

export function getCss(o, key) {
  return o.currentStyle
    ? o.currentStyle[key]
    : window.getComputedStyle(o, false)[key]
}

export function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  console.log(bytes)
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  const base64String = btoa(binary);
  console.log('Binary:', binary); // 检查二进制字符串
  console.log('Base64:', base64String); // 检查Base64字符串
  return base64String;
}

// 将二进制字符串转换为Uint8Array
export function binaryStringToUint8Array(binaryString) {
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }
  return byteArray;
}

// 将Uint8Array转换为Base64字符串
export function uint8ArrayToBase64(uint8Array) {
  const binaryString = String.fromCharCode.apply(null, uint8Array);
  return btoa(binaryString);
}


export function isEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}

export function isPhoneNumber(phoneNumber) {
  const regex = /^1[3-9]\d{9}$/;
  return regex.test(phoneNumber);
}
